var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PosAngleData = require("../abstract/posAngleData.js");
var WidthHeightData = require("../abstract/widthHeightData.js");
var PathData = require("./pathData.js");
var SVGToMesh = require("./../threejsExport/svgToMesh.js");
var cio_config = require("cio-config");

var EllipseData = function (center, angle, width, height, fill, strokeWidth, color) {
    this.makeObservableTreeNode();

    this.addPosAngle(center, angle);
    this.addWidthHeight(width, height);

    this.fill = this.value("fill", true, cio_config.types.any.validator);
    this.strokeWidth = this.value("strokeWidth", true, cio_config.types.positive_float.validator);
    this.color = this.value("color", true, cio_config.types.any.validator);     // if color == null, color is inherited from parent layer

    this.geometry = this.cachedFunction("geometry",
        this._getGeometry,
        [this.pos, this.angle, this.width, this.height]
    );

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        this._getSegmentedGeometry,
        [this.geometry]
    );

    this.boundingBox = this.cachedFunction("boundingBox",
        function () {
            return EllipseData.calculateBoundingBox(this.pos().x, this.pos().y, this.width(), this.height(), this.angle());
        },
        [this.pos, this.angle, this.width, this.height]
    );

    

    SVGToMesh.call(this);

    if (fill != undefined) this.fill(fill);
    if (strokeWidth != undefined) this.strokeWidth(strokeWidth);
    if (color != undefined) this.color(color);
};
lib_core.mixin(EllipseData, lib_core.ObservableTreeNode);
lib_core.mixin(EllipseData, PosAngleData);
lib_core.mixin(EllipseData, WidthHeightData);

module.exports = EllipseData;

lib_core.JsonParser.registerClass(EllipseData, "EllipseData");

EllipseData.prototype._getGeometry = function () {
    var rx = this.width()/2;
    var ry = this.height()/2;
    var path = new lib_geometry.Path()
        .moveTo(this.pos().x, this.pos().y)
        .fromEllipse(rx, ry);
    path = path.rotate(this.angle(), this.pos());
    path.fill(this.fill());
    return path;
};

 

EllipseData.prototype._getSegmentedGeometry = function (precision) {
    if(this.width() === this.height())
        return this._getSimpleCircleGeometry(precision);
    return this.geometry().toSegmented(precision);
};

EllipseData.prototype._getSimpleCircleGeometry = function (precision) {
    console.assert(this.height() === this.width());
    precision = precision || 0.005;
    var points = [];
    var r = this.height()/2;
    points.push(new lib_geometry.Coord(this.pos().x, this.pos().y + r));
    var rotationStep = 2*Math.acos(1-precision/r) * 180/Math.PI;
    if(isNaN(rotationStep))
        rotationStep = 60;
    for(var i = 1; i < 360/rotationStep; i++){
        points.push(points[i - 1].rotate(rotationStep, this.pos()) );
    }
    var poly = new lib_geometry.Polygon(points);
    return poly;
};



EllipseData.calculateBoundingBox = function(cx, cy, width, height, angle) {
    // http://www.iquilezles.org/www/articles/ellipses/ellipses.htm
    angle = angle * Math.PI / 180;
    var ux = width/2 * Math.cos(angle);
    var uy = width/2 * Math.sin(angle);
    var vx = height/2 * Math.cos(angle+Math.PI/2);
    var vy = height/2 * Math.sin(angle+Math.PI/2);

    var w = Math.sqrt(ux*ux + vx*vx);
    var h = Math.sqrt(uy*uy + vy*vy);
    var p = new lib_geometry.Coord(cx-w, cy-h);

    return new lib_geometry.BoundingBox(p.x, p.y, 2*w, 2*h);
};

//Debug code
EllipseData.prototype.expand = function(deterministic, precision) {
    var geometryPath = this.segmentedGeometry(precision).toPath();
    var destination = this.parentCollection[0]; // if no destination is given, expand in own parent
    // this.remove();   // if expanding in own parent, first remove original generator

    var path = new PathData();
    path.strokeWidth(this.strokeWidth());
    path.fromGeometryPath(geometryPath);
    path.addTo(destination);
};
